export const ShipmentType = {
    types: {
        toDoor: "to_door",
        toOffice: "to_office"
    }
}